import { Platform } from "@src/mobile/utils/platform";

/**
 * Shows the native in-app review sheet (App Store / Play Store). No-op on web.
 *
 * Stores throttle review-prompt frequency per app install, so multiple
 * calls in quick succession may not surface the sheet.
 */
export async function requestInAppReview(): Promise<void> {
  if (!Platform.isMobile) {
    return;
  }

  const { InAppReview } = await import("@capacitor-community/in-app-review");
  await InAppReview.requestReview();
}
